/**
 * Add floating label functionality to inputs with .floating-label class
 */
const floatingInput = document.querySelectorAll('.floating-label');
const cf7FormList = document.querySelectorAll('.wpcf7-form');

// Move label based on field value
const fieldValueToggleLabels = (input, textarea, select) => {
  if (input?.value != '') {
    input?.classList.toggle('has-value');
  }

  if (textarea?.value != '') {
    textarea?.classList.toggle('has-value');
  }

  if (select?.value != '') {
    select?.classList.toggle('has-value');
  }
}

// Move label based on input event
const onInputToggleLabels = (input, textarea, select) => {
  input?.addEventListener('input', (event) => {
    input?.classList.toggle('has-value', event.target.value);
  });

  textarea?.addEventListener('input', (event) => {
    textarea?.classList.toggle('has-value', event.target.value);
  });

  select?.addEventListener('change', (event) => {
    select?.classList.toggle('has-value', event.target.value);
  });
}

// Main function. Foreach input, textarea and select add events specified above
if (floatingInput) {
  floatingInput.forEach(inputWrapper => {
    const input = inputWrapper.querySelector('input');
    const textarea = inputWrapper.querySelector('textarea');
    const select = inputWrapper.querySelector('select');

    fieldValueToggleLabels(input, textarea, select);
    onInputToggleLabels(input, textarea, select);
  });
}

// Clear floating labels after successful form submission
if (cf7FormList) {
  cf7FormList.forEach(form => {
    form.addEventListener('wpcf7mailsent', () => {
        floatingInput.forEach(inputWrapper => {
          const input = inputWrapper.querySelector('input');
          const textarea = inputWrapper.querySelector('textarea');
          const select = inputWrapper.querySelector('select');

          fieldValueToggleLabels(input, textarea, select);
        });
    });
  });
}